import { createSlice } from '@reduxjs/toolkit';
import { SaveCaptureProfilesDTO } from 'business/models/Models';

export type ImagingSettingsState = {
  selectedImagingSettingsID: Array<number>;
  selectedImagingSettingsRowNum: Array<number>;
  imagingSettingsDTO: SaveCaptureProfilesDTO;
  selectedRobotId: number;
};
const initialState = {
  selectedImagingSettingsID: [],
  selectedImagingSettingsRowNum: [],
  imagingSettingsDTO: {},
  selectedRobotId: null,
} as ImagingSettingsState;

const imagingSettingsReducer = createSlice({
  name: 'ImagingSettings',
  initialState,
  reducers: {
    setSelectedImagingSettingsID: (state, action) => {
      state.selectedImagingSettingsID = action.payload;
    },
    setSelectedImagingSettingsRowNum: (state, action) => {
      state.selectedImagingSettingsRowNum = action.payload;
    },
    setImagingSettingsDTO: (state, action) => {
      state.imagingSettingsDTO = action.payload;
    },
    setSelectedRobotId: (state, action) => {
      state.selectedRobotId = action.payload;
    },
  },
});

export const {
  setSelectedImagingSettingsID,
  setSelectedImagingSettingsRowNum,
  setImagingSettingsDTO,
  setSelectedRobotId,
} = imagingSettingsReducer.actions;

export default imagingSettingsReducer.reducer;
